import { z } from 'zod/v4'

export const updateFsnNetworkIntegrationSchema = z.object({
  pos_outside_area_enabled: z.boolean().optional(),
  incoming_orders_enabled: z.boolean().optional(),
  website_outside_area_enabled: z.boolean().optional(),
  api_token: z.string().max(500).optional().or(z.literal('')),
  default_delivery_fee: z.string().optional().nullable().or(z.number().min(0).max(9999.99)),
  website_outside_area_delivery_fee: z
    .string()
    .optional()
    .nullable()
    .or(z.number().min(0).max(9999.99)),
  clear_token: z.boolean().optional(),
})

export const checkFsnNetworkTokenSchema = z.object({
  api_token: z.string().max(500).optional(),
})

export const connectFsnNetworkLoginSchema = z.object({
  username: z.string().trim().min(1, 'Enter your FSN shop ID.').max(100),
  password: z.string().min(1, 'Enter your FSN password.').max(255),
})
